// @flow
import AnalyticsWebClient, {
	STARGATE_PROXY_PATH,
	UIEventPayload,
} from '@atlassiansox/analytics-web-client';
import { getAppConfig } from '../store';
import { GLOBAL_PAGE_VIEW_ATTRIBUTE, SPACEPAGE_VIEW_ATTRIBUTE } from '../constants/cq-analytics';

const init = () => {
	const { hostBaseUrl, microsEnvType } = getAppConfig();
	const client = new AnalyticsWebClient(
		{
			env: microsEnvType,
			product: 'confluenceQuestions',
		},
		{ apiHost: new URL(hostBaseUrl).host + STARGATE_PROXY_PATH },
	);

	return client;
};

let analyticsClient: AnalyticsWebClient | null = null;

export const getAnalyticsWebClient = (): AnalyticsWebClient => {
	if (analyticsClient === null) {
		analyticsClient = init();
	}
	return analyticsClient;
};

export function sendScreenEvent(name: String, shouldSkipAttributes?: boolean): void {
	const attributes = shouldSkipAttributes
		? undefined
		: {
				source: getSource(),
			};

	void getAnalyticsWebClient().sendScreenEvent(name, undefined, attributes);
}

export function sendTrackEvent(event: UIEventPayload): void {
	void sendEventWithSource(event, 'sendTrackEvent');
}

export function sendUIEvent(event: UIEventPayload): void {
	void sendEventWithSource(event, 'sendUIEvent');
}

function getSource() {
	const { isGlobalQuestionsPage } = getAppConfig();
	return isGlobalQuestionsPage ? GLOBAL_PAGE_VIEW_ATTRIBUTE : SPACEPAGE_VIEW_ATTRIBUTE;
}

function sendEventWithSource(event: UIEventPayload, type) {
	const finalEvent = {
		...event,
		source: getSource(),
	};
	void getAnalyticsWebClient()[type](finalEvent);
}
